// extracted by mini-css-extract-plugin
module.exports = {"container":"Page_container__0fG1n","hiddenTitle":"Page_hiddenTitle__N48Bq","title":"Page_title__s6ifc","subtitle":"Page_subtitle__PKiKR"};